<sd-push-banner
  [pushBannerData]="pushBannerData"
  [themesConfig]="themesConfig"
  [titleLevel]="7"
  [isCopyTag]="isCopyTag"
  [brand]="brandCorner"
  (copied)="onTagCopied($event)"
  (clickPromoLink)="trackClickEvent($event)"
/>
